export default __webpack_public_path__ + "static/media/Maroni.8a539b13.jpg";